export default __webpack_public_path__ + "static/media/closet2-1024w.6da5200b.webp";